import React from 'react'
import cls from 'classnames'

import {generateUniqueId} from '../../utils/utils'
import classes from './TextArea.module.scss'

export default function TextArea(props) {
	const uniqueId = generateUniqueId()

	return (
		<React.Fragment>
			{
				props.label
					? <label
						className={classes.TextArea__Label}
						htmlFor={uniqueId}
					>
						{props.label}
					</label>
					: null
			}
			<textarea
				id={uniqueId}
				value={props.value}
				className={cls('form-control', classes.TextArea)}
				onChange={event => props.saveText(event.currentTarget.value)}
			>
			</textarea>
		</React.Fragment>
	)
}